var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{ref:"image",attrs:{"src":_vm.source,"max-width":_vm.field.max_width,"max-height":_vm.field.max_height,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }